module.exports = __webpack_public_path__ + "static/media/Pickles.4e4c6462.png";